export default "* Fiskespyd\n* Kaste\n* Præcision\n* Puls\n";